import { render, staticRenderFns } from "./summaryTableV2.vue?vue&type=template&id=8cc22322"
import script from "./summaryTableV2.vue?vue&type=script&lang=js"
export * from "./summaryTableV2.vue?vue&type=script&lang=js"
import style0 from "./summaryTableV2.vue?vue&type=style&index=0&id=8cc22322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports